import { mix } from '@chorda/core';
export const NavbarBrand = (props) => {
    return props && {
        items: props.items
    };
};
export const NavbarItem = (props) => {
    return mix({
        tag: 'a',
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        dom: {
            href: props.link
        },
    });
};
export const NavbarMenu = (props) => {
    return {
        components: {
            start: {
                items: props.start
            },
            end: {
                items: props.end
            }
        }
    };
};
export const NavbarDropdown = (props) => {
    return mix({
        templates: {
            trigger: {
                tag: 'a',
                css: 'navbar-link',
            },
            dropdown: {
                css: 'navbar-dropdown',
                defaultItem: {
                    css: 'navbar-item'
                }
            }
        }
    }, props && {
        css: props.css,
        components: {
            trigger: props.trigger,
            dropdown: {
                items: props.items
            }
        }
    });
};
export const NavbarDivider = () => {
    return {
        tag: 'hr',
        css: 'navbar-divider'
    };
};
export const Navbar = (props) => {
    return mix({
        css: 'navbar',
        templates: {
            brand: {
                weight: -10,
                css: 'navbar-brand',
                defaultItem: {
                    css: 'navbar-item'
                }
            },
            menu: {
                css: 'navbar-menu',
                templates: {
                    start: {
                        css: 'navbar-start',
                        defaultItem: {
                            css: 'navbar-item'
                        }
                    },
                    end: {
                        css: 'navbar-end',
                        defaultItem: {
                            css: 'navbar-item'
                        }
                    }
                }
            },
        }
    }, {
        css: props.css,
        components: {
            brand: props.brand,
            menu: props.menu,
        }
    });
};
